document.addEventListener('DOMContentLoaded', function () {
  var forms = document.querySelectorAll('.js-newsletter-form');

  forms.forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      handleSubmit(form);
    });
  });
});

function handleSubmit(form) {
  var emailInput = form.querySelector('input[name="email"]');
  var honeypot = form.querySelector('input[name="website"]');
  var messageEl = form.querySelector('.js-newsletter-message');
  var buttonText = form.querySelector('.js-newsletter-button-text');
  var spinner = form.querySelector('.js-newsletter-spinner');
  var submitButton = form.querySelector('button[type="submit"]');
  var url = form.getAttribute('data-newsletter-url');
  var email = emailInput.value.trim();

  // Client-side email validation
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showMessage(
      messageEl,
      messageEl.getAttribute('data-invalid-email') ||
        'Veuillez saisir une adresse e-mail valide.',
      'error',
    );
    return;
  }

  // Loading state
  form.setAttribute('aria-busy', 'true');
  submitButton.disabled = true;
  buttonText.classList.add('hidden');
  spinner.classList.remove('hidden');
  messageEl.classList.add('hidden');

  var body = { email: email };

  if (honeypot && honeypot.value) {
    body.website = honeypot.value;
  }

  fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(body),
  })
    .then(function (response) {
      var contentType = response.headers.get('content-type') || '';
      if (!contentType.includes('application/json')) {
        throw new Error('Non-JSON response');
      }
      return response.json().then(function (data) {
        return { ok: response.ok, data: data };
      });
    })
    .then(function (result) {
      if (result.ok && result.data.success) {
        showMessage(messageEl, result.data.message, 'success');
        form.reset();
      } else {
        showMessage(
          messageEl,
          result.data.message || 'Une erreur est survenue.',
          'error',
        );
      }
    })
    .catch(function () {
      showMessage(
        messageEl,
        'Le service est temporairement indisponible.',
        'error',
      );
    })
    .finally(function () {
      form.removeAttribute('aria-busy');
      submitButton.disabled = false;
      buttonText.classList.remove('hidden');
      spinner.classList.add('hidden');
    });
}

function showMessage(el, message, type) {
  el.classList.remove(
    'hidden',
    'text-green-700',
    'bg-green-100',
    'text-red-700',
    'bg-red-100',
  );

  if (type === 'success') {
    el.classList.add('text-green-700', 'bg-green-100');
  } else {
    el.classList.add('text-red-700', 'bg-red-100');
  }

  // Filling a display:none live region yields no announcement: reveal it first.
  el.textContent = message;
}
